<p-table
  [value]="mobileInformations"
  selectionMode="single"
  rowHover="true"
  [style]="{ 'margin-bottom': '10px' }"
>
  <ng-template pTemplate="header">
    <tr>
      <th colspan="5" class="mobile-information-left-align">Mobile Information</th>
    </tr>

    <tr class="whiteBackground">
      <th class="whiteBackground">User</th>
      <th class="whiteBackground">App Version</th>
      <th class="whiteBackground">Device Make & Model</th>
      <th class="whiteBackground">Operating System</th>
      <th class="whiteBackground">Last Updated</th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-item>
    <tr>
      <td class="wrap-text">{{ item?.user?.firstName }} {{ item?.user?.lastName }}</td>
      <td class="wrap-text">{{ item.appVersion }}</td>
      <td class="wrap-text">{{ item.deviceMake }} {{ item.deviceModel }}</td>
      <td class="wrap-text">{{ item.operatingSystem }}</td>
      <td>
        <div>
          {{ item.updatedDateTime | datex : 'DD MMM yyyy HH:mm' }}
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>
